<template>
  <HScaffold :title="useUser.isHavePwd ?'修改登录密码':'设置登录密码'">
    <div style="background-color: white;border-radius: 10px;margin:10px;padding:0 10px 0 10px">
      <div class="eachInputRow">
        <img :src="icon_pwd" height="24px" alt="">
        <form style="width: 100%;">
          <van-field
              maxlength="15"
              type='password'
              v-model="pwdValue1"
              clearable
              placeholder="数字与字母组合(字母开头)"
              @input="onlyNumber(1)"
              autocomplete="false"
          />
        </form>
      </div>
      <van-divider style="margin:5px"/>
      <div class="eachInputRow">
        <img :src="icon_pwd" height="24px" alt="">
        <form style="width: 100%;">
          <van-field
              maxlength="15"
              type='password'
              v-model="pwdValue2"
              clearable
              placeholder="请再次输入密码"
              @input="onlyNumber(2)"
              autocomplete="false"
          />
        </form>
      </div>
    </div>

    <EachLrContent :autoFillPhoneNumber="true" :showLastLine="false" style="margin: 10px;border-radius: 10px;"
                   :valueChangeCallback="valueChangeCallback" :isLogin="true" :isPasswdType="false"/>
    <HButton :disabled="!isCanPress" title="确认" :callback="clickBind"/>


    <HServicePrase/>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import EachLrContent from "@/components/pages/LoginRegister/EachLrContent.vue";
  import HButton from "@/components/utils/HButton.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import {showToast} from "vant";
  import {hr} from "@/components/utils/HRouter.js";
  import icon_pwd from '@/assets/icons/login/lr_pwd.png';
  import HServicePrase from "@/components/utils/HServicePrase.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {hsp, SaveEnum} from "@/components/utils/HSp.js";

  const value1 = ref("");
  const value2 = ref("");
  const pwdValue1 = ref("");
  const pwdValue2 = ref("");
  const isCanPress = ref(false);
  let useUser = useUserStore();
  let useComApi = useHComApi();

  function valueChangeCallback(v1, v2, v3) {
    value1.value = v1;
    value2.value = v2;
    checkIsCanPress();
  }

  function checkIsCanPress(){
    if (value1.value.length >= 11 && value2.value.length >= 4 && pwdValue1.value.length>=6 && pwdValue2.value.length>=2) {
      isCanPress.value = true;
    } else {
      isCanPress.value = false;
    }
  }

  function onlyNumber(type){
    // 只保留数字
    (type === 1 ? pwdValue1 : pwdValue2).value = (type === 1 ? pwdValue1 : pwdValue2).value.replace(/[^a-z0-9]/g, '');
    checkIsCanPress();
  }

  function clickBind() {
    if(pwdValue1.value !== pwdValue2.value){
      return showToast("两次输入的密码不一致，请重新输入");
    }

    useComApi.modifyUserBase({
      "Mobile": value1.value,
      "Captcha": value2.value,
      "Passwd": pwdValue1.value,
      "AreaCode": useUser.areaCode,
    }, () => {
      //如果用户设置了保存密码，就要将新密码重新保存
      let isSavePwd =
          hsp.getBool(SaveEnum.savePwd) ??
          false;
      if (isSavePwd) {
        hsp.setString(SaveEnum.userPwd,
            pwdValue1.value);
      }
      //
      useUser.phoneNumber = value1.value;
      useUser.isHavePwd = true;
      showToast("登录密码设置成功");
      hr.goBack();
    });
  }
</script>


<style scoped>
  .eachInputRow {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
</style>
